// import '../css/Experience.css';

// const Experience = () => {
//     return (
//         <div className='experience-div'>
//             <div className='experience-header'>
//                 <h2>Work Experience</h2>
//             </div>
//             <div className='experience-blocks'>
//             <img src={require('../assets/work-exp/wexp1.png')} alt="wexp1"/>
//             <img src={require('../assets/work-exp/wexp2.png')} alt="wexp2"/>
//             </div>
//         </div>
//     );
// }

// export default Experience;

import '../css/Experience.css';
import {jobs} from '../data/jobs';


const Exp = () => {
    return (
        <div className='experience'>
            <div className='experience-header'>
                 <h2>Work Experience</h2>
            </div>
            <div className='experience-div'>
            
            {
                jobs.map((job) => {
                    return (
                    <div key={job.id} className='exp-div'>
                        <div className='exp-date'>
                            {job.date}
                        </div>
                        <div className='exp-data'>
                            <div className='exp-company'>
                            <a className={job.color} href={job.link}>{job.company}</a>
                            </div>
                            <div className='exp-designation'>
                                <p>{job.designation}</p>
                            </div>
                            <div className='exp-description'>
                                <p>{job.description}</p>
                            </div>
                        </div>
                    </div>
                    );
                })
            }
            </div>
        </div>
    );
}

export default Exp;